// types
import { FilterInputSearchStateSchema } from "../types/filterInputSearchTypes";

export const getFilterInputSearchState = (
  state: FilterInputSearchStateSchema,
) => state.filterInputSearch;
